import { v4 as uuid4 } from "uuid";
/**
 * @name 解析value为crudDatas
 * @param {string} value - 格式: [create]订单,[update]库存
 * @returns {Array}
 */
function parseValueToCrudDatas(value) {
	if (!value) return [];

	return value
		.split(",")
		.map((item, index) => {
			const match = item.trim().match(/\[(\w+)\](.+)/);
			if (match) {
				return {
					id: `crud_${Date.now()}_${index}`,
					type: match[1],
					data: [match[2].trim()],
				};
			}
			return null;
		})
		.filter(Boolean);
}

/**
 * @name 简化JSON
 * @param {*} flowJson
 * @returns
 */
export function simplifyFlowWithMapping(flowJson) {
	const shortToLong = {};
	const longToShort = {};

	let nodeIndex = 1;

	const nodes = flowJson.nodes.map((node) => {
		const shortId = `n${nodeIndex++}`;

		shortToLong[shortId] = node.id;
		longToShort[node.id] = shortId;

		return {
			id: shortId,
			type: node.data?.type,
			name: node.data?.title,
		};
	});

	const edges = (flowJson.edges || []).map((edge) => ({
		from: longToShort[edge.source],
		to: longToShort[edge.target],
	}));

	return {
		flow: {
			nodes,
			edges,
		},
		shortToLong,
		longToShort,
	};
}

/**
 * @name 应用修改
 * @param {*} flowJson
 * @param {*} operations
 * @param {*} handlers - { handleNodeAdd, handleNodeDelete, handleNodeDataUpdate }
 * @returns
 */
export function applyOperations(flowJson, operations, handlers) {
	const reg = /\[(create|read|update|delete)\](.*)/;
	const { handleNodeAdd, handleNodeDelete, handleNodeDataUpdate } = handlers;
	const graph = flowJson;

	operations.forEach((op) => {
		switch (op.op) {
			case "addNode": {
				const opr = op.value; // 数据操作
				const crudDatas = [];

				if (opr) {
					// 同时支持中英文逗号
					let oprList = opr.split(",");

					for (const _opr of oprList) {
						let oprs = _opr.match(reg);

						if (oprs && oprs.length == 3) {
							crudDatas.push({ type: oprs[1], data: [oprs[2]] });
						}
					}
				}
				if (
					!op.type ||
					op.type === "assignment-online" ||
					op.type === "assignment-offline"
				) {
					handleNodeAdd(
						{
							nodeType: op.type || "assignment-online",
							toolDefaultValue: {
								title: op.name,
								id: op.id,
								detail: {
									station: op.station,
									desc: op.desc,
								},
								crudDatas: crudDatas
									? crudDatas.map((item) => ({ ...item, id: uuid4() }))
									: [],
							},
						},
						{
							prevNodeId: op.prevNodeId,
							prevNodeSourceHandle: "source",
							nextNodeId: op.nextNodeId,
							nextNodeTargetHandle: "target",
						},
					);
				} else {
					handleNodeAdd(
						{
							nodeType: op.type,
							toolDefaultValue: {
								title: op.name,
								id: op.id,
								detail: {
									station: op.station,
									desc: op.desc,
								},
							},
						},
						{
							prevNodeId: op.prevNodeId,
							prevNodeSourceHandle: "source",
							nextNodeId: op.nextNodeId,
							nextNodeTargetHandle: "target",
						},
					);
				}

				break;
			}

			case "removeNode": {
				handleNodeDelete(op.id);
				break;
			}

			case "updateNode": {
				const node = graph.nodes.find((n) => n.id === op.id);

				// 忽略分支节点的数据更新
				if (!node || node.data?.type === "middle") {
					break;
				}

				// 更新节点名称
				if (op.name) {
					node.data.title = op.name;
				}

				// 构造更新数据
				const updateData = {};

				// 更新 detail 中的字段
				if (op.station || op.desc) {
					updateData.detail = {
						...(node.data?.detail || {}),
					};
					if (op.station) {
						updateData.detail.station = op.station;
					}
					if (op.desc) {
						updateData.detail.desc = op.desc;
					}
				}

				// 解析 value 为 crudDatas
				if (op.value) {
					updateData.crudDatas = parseValueToCrudDatas(op.value);
				}

				// 调用更新方法
				if (Object.keys(updateData).length > 0) {
					handleNodeDataUpdate({
						id: op.id,
						data: updateData,
					});
				}

				break;
			}
		}
	});

	return flowJson;
}

/**
 * @name 复原Id
 * @param {*} operations
 * @param {*} shortToLong
 * @returns
 */
export function restoreOperationsId(operations, shortToLong) {
	return operations.map((op) => {
		const newOp = { ...op };

		if (op.op === "addNode") {
			newOp.id = newOp.id || `${Date.now()}`;
			newOp.prevNodeId = shortToLong[newOp.prevNodeId];
			newOp.nextNodeId = shortToLong[newOp.nextNodeId];
			return newOp;
		}

		if (op.id && shortToLong[op.id]) newOp.id = shortToLong[op.id];

		return newOp;
	});
}
